import React from 'react';

import {MainLayout} from 'widgets/layout';

import {EmailProblem} from 'features/profile';

const EmailProblemPage: React.FC = () => {
    return <MainLayout isPlugMode>
        <EmailProblem/>
    </MainLayout>;
};

export default EmailProblemPage;